define(function() {
    const IpsModelCollection = require('civicsBase/ipsModelCollection');

    return IpsModelCollection.extend({
        urlRoot: '/delegate/civics-api/api/portal/userrecords',
        url: function(){
            var myUrl = this.urlRoot;
            if(this.servicerequest == true){
                myUrl = myUrl + '?IncludeRequests=true';
                if( this.excludeWizard == true){
                    myUrl = myUrl + '&excludeWizardRecords=true';
                }

                if( this.accountId && this.accountId > 0){
                    myUrl = myUrl + '&accountId=' + this.accountId;
                }
            }
            else if( this.excludeWizard == true){
                myUrl = myUrl + '?excludeWizardRecords=true';
            }
            return myUrl;
        }
    });
});
